import React, { ReactNode, useState } from 'react'

import { AppProvider, ModalsProvider } from '@joehua/cms-components'
import '../icons'
import Logo from '../Logo'
import MenuWithData from '../Menu'
import MobileMenu from '../MobileMenu'
import MobileDrawer from '../MobileDrawer'
import { ThemeProvider } from 'react-css-themr'
import { defaultTheme } from './themes'
import LayoutContact from './Contact'
import { LinkProvider } from '@joehua/react-link'
import Link from '../Link'

import '../../assets/rc-menu.css'
import 'normalize.css/normalize.css'
import 'tachyons/css/tachyons.min.css'
import '../../assets/styles.css'

import appData from '../../data.yml'
import Helmet from 'react-helmet'
import PhoneMe from '../PhoneMe'
import LayoutCta from './Cta';
import { modals } from './modals';

const DesktopMenu = () => (
  <div className="flex items-center justify-around pv2">
    <Logo className="w2 w3-l flex-none ml3" />
    <div className="flex-auto flex items-center justify-end">
      <MenuWithData
        data={{ name: 'main', mode: 'horizontal' }}
        theme={{
          root: 'bn bg-transparent pa0 ma0',
          item: 'bg-transparent fw4',
          itemLink: 'f6 db pc grow ph3 pv2',
          popupClassName: 'bg-near-white pt3',
        }}
      />
      <PhoneMe />
    </div>
  </div>
)

export default function Layout({ children }: { children: ReactNode }) {
  const [isShowDrawer, onShowDrawerChange] = useState(false)
  const links = appData.data.links || []
  return (
    <AppProvider value={{ app: appData }}>
      <Helmet>
        <html lang={appData.lang} />
        {links.map((item: any, idx: number) => (
          <link rel="preload" key={idx} {...item} />
        ))}
      </Helmet>
      <ThemeProvider theme={defaultTheme as any}>
        <LinkProvider Link={Link}>
        <ModalsProvider modals={modals}>
          <>
            <div className="dn db-l shadow-4 pv1 mw9 center ph4-l bg-near-white sticky z-3">
              <DesktopMenu />
            </div>
            <div className="dn-l">
              <MobileMenu
                isShowDrawer={isShowDrawer}
                onToggleDrawer={() => onShowDrawerChange(!isShowDrawer)}
              />
            </div>
            <div>{children}</div>
            <LayoutCta />
            <LayoutContact />
            <MobileDrawer
              isOpen={isShowDrawer}
              onClose={() => onShowDrawerChange(false)}
              theme={{
                menu: {
                  root: 'tc w-100',
                  item: 'tc',
                  itemLink: 'pf f6 db pc ph3 pv2',
                },
              }}
            />
            <div className="ph2 tc pv2 pv3-ns bg-light-gray f7 f6-l mb5">
              <div className="mw8 center flex justify-between">
              <span className="silver">2019 conghoagarden.com.vn.</span>
              <a href="/pg/dieu-khoan-su-dung" className="link moon-gray">Điều khoản sử dụng</a>
              <a href="/pg/quyen-rieng-tu" className="link moon-gray">Quyền riêng tư</a>
              </div>
            </div>
          </>
          </ModalsProvider>
        </LinkProvider>
      </ThemeProvider>
    </AppProvider>
  )
}
